import { Grid } from '@chakra-ui/react';
import Pharmacy from '../types/Pharmacy';
import Prescriptions from '../types/Prescriptions';
import Providers from '../types/Providers';

const MapdColumns = ({ prescriptions, primaryProviders, specialistProviders, pharmacy, onFilterChange, user }) => (
  <Grid
    templateColumns={[
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      'minmax(280px, 3fr) minmax(280px, 4fr) minmax(220px, auto)',
    ]}
    minH="240px"
    columnGap={[4, 4, 4, 8]}
    overflow="hidden"
    sx={{
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      flex: 'wrap',
      ' > div': {
        flex: '1 !important',
      },
    }}
    flexWrap="wrap"
  >
    <Providers
      user={user}
      primaryProviders={primaryProviders}
      specialistProviders={specialistProviders}
      onFilterChange={onFilterChange}
    />
    <Prescriptions prescriptions={prescriptions} onFilterChange={onFilterChange} />
    <Pharmacy pharmacy={pharmacy} />
  </Grid>
);

export default MapdColumns;
